import { createContext } from 'react';
export const modalsControllerContext = createContext(undefined);
export const modalsContext = createContext(undefined);
